/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const S3_PREFIX = "https://media.werz.at/community-assets/hydriga"

const hybrida: CommunityData = {
  code: "hybrida",
  name: "Hybrida",
  inviteCode: "hybrida",
  thumbnail: "",
  favicon: "",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/hyb-312`,
  socials: {
    instagramLink: "",
    soundcloudLink: "",
  },
  styles: {
    global: {
      counterColor: "#FF4D00",
      alternativeLogo: {
        src: `${S3_PREFIX}/web-alternative-logo.png`,
        styles: "w-[128px] object-contain",
      },
      logo: {
        src: `${S3_PREFIX}/web-logo.png`,
        styles: "w-[128px] object-contain",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      bgColor: "#6F8DB2",
      asideBg: "",
      asideStyles:
        "border-x-[1px] border-[#FFFFFF] sm:bg-gradient-to-b from-[#E12D1F] via-[#6F8DB2] via-[62%] to-[#A6B0B0]",
      contentBg: "transparent",
      contentBoxShadow: "border border-[#FFFFFF]",
      bgDesktop: `${S3_PREFIX}/web-bg.jpg`,
      bgMobile: `${S3_PREFIX}/web-bg.jpg`,
      nonMemberBg: `${S3_PREFIX}/web-bg.jpg`,
      mainFont: "font-['Poppins-Regular']",
      primaryButton:
        "w-full sm:w-fit bg-[#FFFFFF] !text-[#000000] !px-6 !py-4 font-['Poppins-Regular'] text-[16px] leading-[24px] whitespace-nowrap border border-[#FFFFFF]",
    },
    navigation: {
      iconsColor: "#000000",
      sideBarSeparator: "border-r border-[#FFFFFF]",
      separator: "border-t border-[#FFFFFF]",
      item: "-ml-4 text-center opacity-50 !py-4 text-[#FFFFFF] font-['Poppins-Regular'] !text-[16px] !leading-[1]",
      itemSelected: "!opacity-100",
    },
    communityLanding: {
      container: "!p-0 !m-0",
      titles:
        "font-['Poppins-Medium'] text-[28px] text-[#FFFFFF] !font-normal !mb-6 tracking-[0.04em]",
      emptyOrLoadingState: "!mx-4 sm:!mx-8 font-['Poppins-Regular'] text-[14px] text-[#FFFFFF]",
      announcementsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 !space-y-0 border-b border-[#FFFFFF]",
        sectionTitle: "pl-4 sm:!pl-8 !pb-4 !sm:pb-6 !tracking-[0.04em]",
        scrollMenu: {
          container: "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 gap-x-4",
          wrapper: "relative group",
          item: "w-fit",
        },
        item: {
          container:
            "min-w-[calc(100vw-48px)] sm:min-w-[256px] sm:max-w-[256px] border border-[#FFFFFF] h-full overflow-hidden",
          mediaContainer: "w-full sm:w-[256px] !aspect-square relative",
          media: "w-full !aspect-square object-cover",
          placeholderMedia: "w-full h-full bg-gray-400",
          content: "flex flex-col p-4 border-t border-[#FFFFFF]",
          title: "font-['Poppins-Medium'] text-[18px] text-[#FFFFFF] leading-[1.2]",
          subtitle: "font-['Poppins-Regular'] text-[14px] text-[#FFFFFF] leading-[1] mt-2",
        },
      },
      eventsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 !space-y-0 border-y border-[#FFFFFF]",
        sectionTitle: "pl-4 sm:pl-8 !pb-4 sm:pb-6",
        scrollMenu: {
          container:
            "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 !h-full sm:!h-[128px] flex-row gap-6",
          wrapper: "relative group w-full",
          item: "w-fit",
        },
        item: {
          container:
            "flex sm:flex-row flex-col w-[calc(100vw-56px)] sm:!w-[428px] border border-[#FFFFFF] h-full overflow-hidden",
          mediaContainer: "w-full sm:!w-[228px] h-[256px] sm:!h-[128px] sm:flex-shrink-0 relative",
          media: "w-full !aspect-video object-cover",
          placeholderMedia: "w-full h-full bg-gray-400",
          content: "flex flex-col p-4 border-t sm:border-t-0 sm:border-l border-[#FFFFFF]",
          title: "font-['Poppins-Medium'] text-[18px] text-[#FFFFFF] leading-[1.2]",
          subtitle: "font-['Poppins-Regular'] text-[14px] text-[#FFFFFF] leading-[1] mt-2",
          location: "font-['Poppins-Regular'] text-[14px] text-[#FFFFFF] leading-[1] mt-2",
          date: "font-['Poppins-Regular'] text-[14px] text-[#FFFFFF] leading-[1] mt-2",
        },
      },
      shop: {
        container: "py-4 sm:py-8 !pb-16 !m-0 space-y-0",
        title: "font-['Poppins-Medium'] text-[20px] text-[#FFFFFF]",
        text: "font-['Poppins-Regular'] text-[16px] text-[#FFFFFF]",
        customShopImageStyle: "w-full h-full object-cover border border-[#FFFFFF]",
        customShopImage: "https://media.werz.at/community-assets/hybrida/hybrida-landing-shop.png",
        sectionTitle: "!mb-4 !sm:mb-6",
      },
    },
    eventV2: {
      container: "flex flex-col",
      eventInfo: {
        container: "flex flex-col sm:flex-row gap-4 sm:gap-8 sm:p-8 p-4 border-b border-[#FFFFFF]",
        media: "sm:!w-[320px] !w-full !h-[180px] object-cover sm:mb-4 border border-[#FFFFFF]",
        title: "font-['Poppins-Medium'] text-[28px] text-[#FFFFFF] tracking-[0.04em] mb-2",
        subtitle: "font-['Poppins-Regular'] text-[14px] text-[#FFFFFF] mb-4",
        button: "!w-fit mb-4 sm:mb-0",
        questions: "font-['Poppins-Regular'] text-[14px] text-[#FFFFFF]",
      },
      about: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#FFFFFF]",
        header: "font-['Poppins-Medium'] text-[28px] text-[#FFFFFF] tracking-[0.04em]",
        text: "font-['Poppins-Regular'] text-[14px] text-[#FFFFFF] w-full",
      },
      location: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#FFFFFF]",
        header: "font-['Poppins-Medium'] text-[28px] text-[#FFFFFF] tracking-[0.04em]",
        text: "font-['Poppins-Regular'] text-[14px] text-[#FFFFFF] max-w-[652px] w-full",
        map: "sm:w-[350px] w-full h-[206px] !overflow-hidden border border-[#FFFFFF]",
        mapPinColor: "#FFFFFF",
        mapStrokeColor: "#FFFFFF",
      },
      downloadWERZ: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header: "font-['Poppins-Medium'] text-[28px] text-[#FFFFFF] tracking-[0.04em]",
        text: "font-['Poppins-Regular'] text-[14px] text-[#FFFFFF] sm:w-[550px]",
      },
      tickets: {
        header: "font-['Poppins-Medium'] text-[28px] text-[#FFFFFF] tracking-[0.04em]",
        outerContainer: "flex flex-col sm:p-8 p-4",
        innerContainer: "flex flex-col border border-[#FFFFFF] border-b-0 mt-4 sm:mt-6",
        ticket: {
          container:
            "flex flex-row justify-between gap-4 !p-4 border-b border-[#FFFFFF] leading-auto tracking-[0.04em]",
          media: "!hidden",
          name: "font-['Poppins-Medium'] text-[16px] text-[#FFFFFF]",
          description: "font-['Poppins-Regular'] text-[14px] text-[#FFFFFF]",
          price: "font-['Poppins-Medium'] text-[16px] text-[#FFFFFF]",
          quantity: "font-['Poppins-Regular'] text-[14px] text-[#000000]",
          status: "font-['Poppins-Medium'] text-[16px] text-[#FFFFFF] text-right",
          counterContainer:
            "p-3 !w-fit font-['Poppins-Regular'] text-[14px] !text-[#000000] bg-[#FFFFFF] border border-[#FFFFFF]",
          button:
            "font-['Poppins-Regular'] text-[14px] py-3 px-4 bg-[#FFFFFF] text-[#000000] !w-fit border border-[#FFFFFF]",
          plusMinusColor: "#000000",
        },
      },
    },
  },
}

export default hybrida
